// Публичные auth-эндпоинты (не требуют JWT-токена).

import client from './client';

/** Запросить письмо для сброса пароля. Всегда возвращает 200. */
export const forgotPassword = (email) =>
  client.post('/auth/forgot-password', { email });

/** Установить новый пароль по токену из письма. */
export const resetPassword = (token, new_password) =>
  client.post('/auth/reset-password', { token, new_password });

/** Подтвердить email по токену из письма. */
export async function verifyEmail(token) {
  const response = await client.get(`/auth/verify-email?token=${token}`);
  return response.data;
}

/** Повторно отправить письмо с верификацией. Всегда возвращает 200. */
export const resendVerification = (email) =>
  client.post('/auth/resend-verification', { email });
